<template>
  <div>{{ alertMessage }}</div>
</template>

<script>
export default {
  data: function () {
    return {
      alertMessage: null,
    };
  },
  created() {
    this.alertMessage = this.$store.getters.errorMsg;
    this.$store.dispatch('resetErrorMsg');
  },
};
</script>

<style>
</style>